/**
 * Geteilte Markdown-Darstellung (react-markdown + GFM) in kompaktem Stil.
 * Genutzt vom Schema-Browser (F29/F31) und vom Präzisierungs-Assistenten.
 * Code-Blöcke (```…```) für Ninox-Formeln/Trigger werden monospaced gerendert.
 */

import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"

export function Markdown({ inhalt }: { inhalt: string }) {
  return (
    <div className="min-w-0 text-sm leading-relaxed [&_code]:rounded [&_code]:bg-muted [&_code]:px-1 [&_code]:font-mono [&_code]:text-xs">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ children }) => <h1 className="mb-3 mt-1 text-lg font-bold">{children}</h1>,
          h2: ({ children }) => (
            <h2 className="mb-2 mt-6 border-b pb-1 text-[15px] font-bold">{children}</h2>
          ),
          h3: ({ children }) => <h3 className="mb-1.5 mt-4 text-sm font-bold">{children}</h3>,
          p: ({ children }) => <p className="mb-2">{children}</p>,
          ul: ({ children }) => <ul className="mb-2 list-disc pl-5">{children}</ul>,
          pre: ({ children }) => (
            <pre className="mb-3 overflow-x-auto rounded-lg bg-muted/60 p-3 text-[12px] leading-5">
              {children}
            </pre>
          ),
          table: ({ children }) => (
            <div className="mb-4 overflow-x-auto">
              <table className="w-full border-collapse text-[13px]">{children}</table>
            </div>
          ),
          th: ({ children }) => (
            <th className="border-b bg-muted/60 px-2.5 py-1.5 text-left font-semibold">
              {children}
            </th>
          ),
          td: ({ children }) => <td className="border-b px-2.5 py-1.5 align-top">{children}</td>,
          hr: () => <hr className="my-4" />,
        }}
      >
        {inhalt}
      </ReactMarkdown>
    </div>
  )
}
